<!--
 * @Description: 临时用工详情页
-->
<template>
  <div class="FlexibleDetail_page">
    <div  v-loading="loadingTrue">
    <EmptyData :type="state" v-if="state!=1">
      当前数据已{{state==2?'下架':'删除'}}，点击 <a @click="handleBack">返回列表</a> 继续浏览吧~
    </EmptyData>

    <div class="leftBox"  element-loading-background="rgba(255, 255, 255, 1)" v-if="state==1">
      <div class="item_top">
        <div class="title">
          <div class="name">
            <span
              class="state"
              v-if="Detail.employmentStatus"
              :style="
                Detail.employmentStatus === 1
                  ? { backgroundColor: '#e1251b' }
                  : ''
              "
            >
              {{ Detail.employmentStatusName }}
            </span>
            <!-- <span class="titleName">{{ Detail.projectName }}-{{Detail.workTypeName}}</span> -->
            <!-- formattingWorkTypeName(显示几个) 格式化 ：标题的工种最多显示五个； -->
            <span class="titleName">{{ Detail.projectName }}-{{Detail.workTypeName | formattingWorkTypeName(5)}}</span>
          </div>
        </div>
        <div class="detailBody">
          <el-row :gutter="24">
            <el-col :span="8">
              <div class="item_text single_hide" style="padding-bottom:0px">
                <span class="item_icon">
                  <img style="width:24px;height:24px" src="@/assets/temporary/danwei.png" alt="" />
                </span>
                <span class="color6">用工单位:</span>
                <span class="item_right" style="color:#0286DF;">{{
                  Detail.employmentCompany
                }}</span>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="item_text single_hide" style="padding-bottom:0px">
                <span class="item_icon">
                  <img style="width:24px;height:24px" src="@/assets/temporary/dizhi.png" alt="" />
                </span>
                <span class="color6">工作地址:</span>
                <div @mouseenter="handleShowTooltip($event)">
                  <el-tooltip popper-class="popperCustoms" :visible-arrow="false" :disabled="showTooltip"  placement="bottom" class="single_hide" effect="light">
                    <div class=" color3 single_hide" style="color: #333;max-width:222px">{{ Detail.provinceName}}{{ Detail.cityName}}{{ Detail.areaName}}{{ Detail.address}}</div>
                    <div slot="content"  style="color: #666;">{{ Detail.provinceName}}{{ Detail.cityName}}{{ Detail.areaName}}{{ Detail.address}}</div>
                  </el-tooltip>
                </div>
                <span
                  @click="showMap"
                  style="marginLeft:5px;cursor:pointer;width:30px;height:26px"
                  v-if="Detail.longitude && Detail.latitude"
                >
                  <img src="@/assets/public/map.jpg" alt />
                </span>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="item_text single_hide" style="padding-bottom:0px">
                <span class="item_icon">
                  <img style="width:24px;height:24px" src="@/assets/temporary/kssj.png" alt="" />
                </span>
                <span class="color6">开始时间:</span>
                <span class="item_right color3">
                  {{ Detail.startTime?formatTime(Detail.startTime):'/' }}
                </span>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="8">
              <div class="item_text single_hide" style="padding-bottom:0px">
                <span class="item_icon">
                  <img style="width:24px;height:24px" src="@/assets/temporary/ygfs.png" alt="" />
                </span>
                <span class="color6">用工方式:</span>
                <span v-if="Detail.salaryType==4||Detail.salaryType==5||Detail.salaryType==6" class=" color3">
                  {{Detail.salaryTypeName? Detail.salaryTypeName: "/"}}
                </span>
                <span v-if="Detail.salaryType==1||Detail.salaryType==2||Detail.salaryType==3" class=" color3">/</span>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="item_text single_hide" style="padding-bottom:0px">
                <span class="item_icon">
                  <img style="width:24px;height:24px" src="@/assets/temporary/xinzi.png" alt="" />
                </span>
                <!-- 薪资： -->
                <span class="color6">薪资:</span>
                <span v-if="Detail.salaryType==1 || Detail.salaryType==2" class=" color3">{{Detail.salaryTypeName}}</span>
                <span class=" color3" v-if="!Detail.salaryType || Detail.salaryType==3||Detail.salaryType==5||Detail.salaryType==6">
                  {{ Detail.salary | formattingSalary }}元/{{Detail.salaryUnitName}}
                </span>
                <span v-if="Detail.salaryType==4" class="color3">{{ Detail.salary }}元/{{Detail.taskVolumeUnit}}</span>

              </div>
            </el-col>
            <el-col :span="8">
              <div class="item_text single_hide" style="padding-bottom:0px">
                <span class="item_icon">
                  <img style="width:24px;height:24px" src="@/assets/temporary/kssj.png" alt="" />
                </span>
                <span class="color6">结束时间:</span>
                <span class=" color3">
                  {{
                    Detail.endTime?formatTime(Detail.endTime):'/'
                  }}
                </span>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="8">
              <div class="item_text single_hide" style="padding-bottom:0px">
                <span class="item_icon">
                  <img style="width:24px;height:24px" src="@/assets/temporary/lianxiren.png" alt="" />
                </span>
                <span class="color6">联系人:</span>
                <span class=" color3">{{ Detail.contact|formatContactName }}</span>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="item_text single_hide" style="padding-bottom:0px">
                <span class="item_icon">
                  <img style="width:24px;height:24px" src="@/assets/temporary/dianhua.png" alt="" />
                </span>
                <span class="color6">联系电话:</span>
                <span class=" color3" v-if="showpNumber">{{ Detail.contactPhone }}</span>
                <span class=" color3" v-else>{{ ShowPhone(Detail.contactPhone) }}</span>
                <span style="color:#0286DF;cursor: pointer;margin-left:10px" v-if="!showpNumber" @click="ShowPhoneNumber" >查看</span>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="item_text single_hide" style="padding-bottom:0px">
                <span class="item_icon">
                  <img style="width:24px;height:24px" src="@/assets/temporary/renshu.png" alt="" />
                </span>
                <span class="color6">用工数量:</span>
                <span class=" color3">
                  {{
                    Detail.employmentNumber
                      ? Detail.employmentNumber + "人"
                      : "/"
                  }}
                </span>
              </div>
            </el-col>
          </el-row>
        </div>
        <div>
          <btns :item="Detail" :type="4" @end="getDetail" @changeStatus="v=>state=v"></btns>
        </div>
        <div style="padding:0 20px;position: relative;">
        <div class="little-tips">联系时，请说明是在“经营帮”上看到的</div>
        <div v-if="Detail.updateTime===Detail.createTime" class="createTime color6">{{Detail.createTime | formatDate}}发布</div>
        <div v-else class="createTime color6">{{Detail.updateTime | formatDate}}更新</div>
        </div>
      </div>
      <div class="signUp_tab">
        <el-tabs
          v-model="activename"
          type="card"
          @tab-click="handleClick"
          id="pane"
        >
          <el-tab-pane label="用工详情" activeIndex="0" key="tab1">
            <Tab1 :Detail="Detail" style="position: relative;margin: -16px 0px;bottom: -8px;"></Tab1>
          </el-tab-pane>
          <!-- <el-tab-pane label="报名列表" activeIndex="1" key="tab2">
            <div v-if="tableData.length">
              <SignUpTableList
                v-if="tableData.length > 0"
                :data="tableData"
                :loadingTrue="loadingTrue"
              ></SignUpTableList>
              <BaseEmptyData isDetail v-else></BaseEmptyData>
              <Pagination
                :isList="false"
                :param="params"
                @change="getSignUpList"
                v-if="tableData.length > 0"
                :loadingTrue="loadingTrue"
              ></Pagination>
            </div>
            <nodata v-else></nodata>
          </el-tab-pane> -->
          <el-tab-pane label="报名要求" activeIndex="2" key="tab3">
            <Tab3 v-if="Detail.tab3" :Detail="Detail" style="position: relative;margin: -16px 0px;bottom: -8px;"></Tab3>
            <nodata v-else></nodata>
          </el-tab-pane>
          <el-tab-pane label="用工计划" activeIndex="3" key="tab4">
            <Tab4 v-if="Detail.tab4" :Detail="Detail" style="position: relative;margin: -16px 0px;bottom: -8px;"></Tab4>
            <nodata v-else></nodata>
          </el-tab-pane>
        </el-tabs>
      </div>

      <!-- 推荐列表 -->
      <div class="recommendList">
        <div class="title">
          <div class="name">相关用工推荐</div>
          <div class="more" @click="$router.replace('/FlexibleEmployment');reload()">
            查看更多
            <img src="@/assets/teamIcon/more.png" alt="">
          </div>
        </div>

        <div>
          <el-row style="padding: 0 20px 20px;" :gutter="20" v-if="recommendedList.length">
            <el-col v-for="(item, index) in recommendedList" :span="12" :key="index">
              <card :item="item" :type="4"></card>
            </el-col>
          </el-row>
        </div>

        <BaseEmptyData isDetail v-if="!recommendedList.length && !loadingTrue"></BaseEmptyData>

      </div>
    </div>
    <!-- 地图 -->
    <el-dialog
      center
      title="地图显示"
      :visible.sync="mapDiaVisible"
      width="70%"
      :close-on-click-modal="false"
    >
      <span>
        <i class="el-icon-location-outline"></i>
        <span>所在地区:</span>
        {{ Detail.location ? Detail.location : "" }}
        {{ Detail.address ? "" + Detail.address : "" }}
      </span>
      <Mapdetail
        ref="childDataDt"
        :center="mapCenter"
        :position="mapPosition"
        :text="text"
      ></Mapdetail>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="mapDiaVisible = false">
          关 闭
        </el-button>
      </div>
    </el-dialog>
    </div>
  </div>
</template>

<script>
import { apiFlexibleEmployment } from "@/api/apiFlexibleEmployment"
import cookie from "@/storage/cookies.js"
import {api} from '@/api/apiRecommendedList'
export default {
  inject: ['reload'], // 引入App.vue 中的刷新页面的方法
  data() {
    return {
      showpNumber: false,
      showTooltip:false,
      state:1, // 数据状态：1 正常；2 下架； 3 删除
      isAttention: false,
      inByLetDialogShow: false,
      activename: "0",
      tips: "注：工人和班组队用工满意的话，可以直接进行电话联系",
      tipsTwo: "联系时，请说明是在“经营帮”上看到的",
      isCanLookPhone: false,
      loadingTrue: false,
      Detail: {},
      recommendList: [],
      tableData: [],
      // 地图经纬度信息
      mapCenter: [],
      mapPosition: [],
      text: {
        text: "",
        offset: [0, -50]
      },
      mapDiaVisible: false,
      param: {
        page: 1,
        limit: 6,
        provinceNo: "", // 省
        cityNo: "", // 市
        areaNoList: [], // 区
        categoryNo: "",
        employmentStatus: null, // 状态
        employmentType: null, // 类型
        workType: ""
      },
      params: {
        page: 1,
        limit: 20,
        relationNo: "",
        type: 2
      },
      recommendedList:[]
    }
  },

  components: {
    SignUpTableList: () => import("./signUpTableList.vue"), // 报名列表
    Mapdetail: () => import("@/components/public/components/mapDetail"),
    BaseEmptyData: () => import("@/components/public/BaseEmptyData"),
    CountDown: () => import("./components/CountDown"), // 倒计时组件
    Tab1: () => import("./FlexibleDetailTab1"), // 用工详情
    Tab3: () => import("./FlexibleDetailTab3"), // 报名要求
    Tab4: () => import("./FlexibleDetailTab4"), // 计划招聘
    nodata: () => import("@/components/public/UI/NoData"), // 无数据
    Pagination: () => import("@/views/Construction/components/Paginationdeltop"), // 分页
    btns: () => import("@/components/details/btns"), // 按钮组
    EmptyData:()=>import("@/components/public/UI/EmptyData"), // 数据被删除/下架显示的缺省图
    card:()=>import('@/components/card/cardFlexibleEmployment.vue'), // 临时用工card
  },
  created() {
    //this.getRecommendList()
    if (this.$route.query) {
      // this.getSignUpList()
      this.getDetail(this.$route.query.no)
    }
  },
  methods: {
    formatTime(time, format = 'YYYY-MM-DD') {
      return moment(time).format(format)
    },
    //隐藏联系号码
    ShowPhone(phone) {
      if (phone && phone.length === 11) {
        const number = `${phone.slice(0, 3)}****${phone.slice(7, 11)}`
        return number
      }
    },
    //查看联系方式
    ShowPhoneNumber() {
      if (this.$store.state.loginType) {
        this.showpNumber = true
      } else {
        this.loginIndex()
      }
    },
    //内容超出时,hover显示所有文本信息
    handleShowTooltip(event){
      let cell = event.target.querySelector('.el-tooltip');
      this.showTooltip = cell.scrollWidth === cell.offsetWidth;
    },
    loginIndex() {
      let data = {
        callBack: function() {
          this.$store.dispatch("setUser")
          this.pushThis()
        }.bind(this)
      }
      this.$_login(data)
    },
    handleClick(tab) {},
    // 隐藏号码中间4位数
    starPhone(phoneNum) {
      let str = String(phoneNum)
      return str.substr(0, 3) + "****" + str.substr(7)
    },
    // 点击'查看联系方式'按钮
    queryContactType() {
      let token = this.$store.state.token
      if (!token) {
        this.loginIndex()
      } else {
        this.isCanLookPhone = true
      }
    },
    async getDetail(no) {
      this.loadingTrue = true
      let res = await apiFlexibleEmployment.GetDetail(no)
      this.Detail = this.showtab(res.data.data)
      let apply=await apiFlexibleEmployment.IsApply({employmentNo:no})
      this.Detail.isApply=apply.data.data
      this.loadingTrue = false
      this.getRecommendedList()
    },
    async getDetailapi(){
      let res = await apiFlexibleEmployment.GetDetail(this.$route.query.no)
      return res.data.data;
    },
    //计算显示的tab标签，有数据再显示出来
    showtab(Detail={}){
      let key3=['ageRquirement','sexRquirement','nationRquirementName','workYearRquirement','healthProve','performanceRquirement',"customField"];
      key3.map(v=>{
        if(Detail[v])Detail.tab3=true;
      })
      let key4=['workTypeName','employmentNumber','industryName','duration'];
      key4.map(v=>{
        if(Detail[v])Detail.tab4=true;
      })
      // if(Detail.workTypeName){
      //   let arr=Detail.workTypeName.split(',');
      //   if(arr.length>5)Detail.workTypeName=arr.splice(0,5).join(',')
      // }
      return Detail
    },
    /** @name 获取工人列表数据 */
    async getRecommendList() {
      this.param.provinceNo = JSON.parse(cookie.cookieRead("area")).id
      let res = await apiFlexibleEmployment.Getemployment(this.param)
      if (res.data && res.data.code === 200) {
        this.recommendList = res.data.data.records
      }
    },
    /** @name 获取报名列表 */
    async getSignUpList() {
      this.params.relationNo = this.$route.query.no
      this.loadingTrue = true
      let res = await apiFlexibleEmployment.GetSignUpList(this.params)
      this.tableData = res.data.data.records
      this.loadingTrue = false
      this.$set(this.params, "total", res.data.data.total)
    },
    /**
     * @description:显示地图
     */
    showMap() {
      let temp = [Number(this.Detail.longitude), Number(this.Detail.latitude)]
      this.mapCenter = temp
      this.mapPosition.push(Number(temp[0]))
      this.mapPosition.push(Number(temp[1]))
      this.mapDiaVisible = true
    },
    handleBack(){
      const referrer = document.referrer
      if(referrer.includes('FlexibleDetail')){
        this.$router.replace('/FlexibleEmployment')
      } else {
        window.location.href = referrer
      }
    },
    /**
     * 获取推荐列表
     */
    async getRecommendedList(){
      this.loadingTrue = true
      const {workType, no:employmentNo, provinceNo} = this.Detail
      const params = {
        workType : workType && workType[0], // 工种no取第一个
        employmentNo, // 临时用工详情no
        provinceNo, // 省编号
      }
      const res = await api.getEmploymentRecommend(params)
      if(res.data.code===200){
        this.recommendedList = res.data.data.slice(0,6)
      }else {
        this.$message.error('系统异常，请稍后再试')
        this.recommendedList = []
      }
      this.loadingTrue = false
    },
    getList(){
      this.getRecommendedList()
    }
  },
  provide(){
    return {
      cardListCom:this
    }
  }
}
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
div {
  box-sizing: border-box;
}
.color6 {
  color: #666666;
}
.FlexibleDetail_page {
  padding-top: 10px;
  width: 1200px;
  font-size: 16px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  .leftBox {
    width: 1200px;
    .top_title {
      display: flex;
      align-items: center;
      height: 50px;
      font-size: 19px;
      border-bottom: 1px solid #eee;
      img {
        width: 22px;
        height: 22px;
        margin-right: 10px;
      }
    }
    .item_top {
      background-color: #fff;
      border: 1px solid #e4e7ed;

      .title {
        text-align: center;
        // border-bottom: 1px dashed #e4e7ed;
        // padding: 20px 0;
        padding-top: 20px;
        position: relative;
        .name {
          // margin: 10px 0;
          display: flex;
          align-items: center;
          justify-content: center;
            // height: 20px;
          .state {
            width: 34px;
            height: 20px;
            line-height: 20px;
            text-align: center;
            display: inline-block;
            // background-color: #409ee9;
            background: #E1251B;
            color: #ffffff;
            font-size: 12px;
            margin-top: 2px;
          }
          .titleName {
            margin-left: 5px;
            font-size: 18px;
            color: #333333;
          }
        }
        .time {
          font-weight: normal;
          font-size: 16px;
          color: #ff6600;
          .time-icon {
            width: 16px;
            height: 16px;
            margin-right: 4px;
            margin-bottom: -1px;
          }
        }
      }
      .detailBody {
        padding-left: 20px;
        padding-right: 20px;
        .single_hide {
          // 单行隐藏
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .color3 {
          color: #333333;
        }
        .item_text {
          font-size: 14px;
          width: 100%;
          font-weight: 400;
          color: #666666;
          display: flex;
          align-items: center;
          padding: 20px 0;
          .color3 {
            color: #333333;
          }
          .item_icon {
            width: 24px;
            height: 24px;
            padding: 0 10px;
          }
        }
        .top-text {
          display: flex;
          justify-content: space-between;
          font-size: 12px;
          color: #969696;
          .tips {
            padding-bottom: 20px;
            padding-left: 20px;
          }
          img {
            margin-right: 5px;
          }
          .num {
            color: #333;
            padding: 0 5px;
          }
          .fx {
            display: flex;
          }
          .ls {
            display: flex;
            margin-top: 10px;
            .lianxi {
              margin: 0 10px;
            }
          }
        }
      }
      .little-tips {
        border-top: 1px dashed #e4e7ed;
        padding-top: 10px;
        margin-bottom:10px;
        color: #969696;
        font-size: 14px;
      }
      .createTime{
        font-size: 14px;
        color: #666666;
        position: absolute;
        right: 20px;
        top: 10px;
      }
      .tips {
        color: #969696;
        font-size: 14px;
      }
      .top_tit {
        margin-top: 20px;
        display: flex;
        align-items: center;
        .end_date {
          color: #666666;
          padding: 0 10px;
          font-size: 14px;
        }
        img {
          width: 50px;
          height: 20px;
        }
      }
      .top_content {
        position: relative;
        .state {
          width: 84px;
          height: 84px;
          position: absolute;
          top: -88px;
          right: 120px;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .single_hide {
          // 单行隐藏
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .item_text {
          font-size: 14px;
          font-weight: 400;
          color: #666666;
          line-height: 32px;
          .phoneBtn {
            color: #0286df;
            padding-left: 20px;
            cursor: pointer;
          }
        }
        .item_tag {
          color: #333333;
        }
      }
    }
    .signUp_tab {
      border: 1px solid #e4e7ed;
      background-color: #fff;
      margin-top: 10px;

      /deep/ .el-tabs__item{
        box-sizing: border-box;
        padding:0 !important;
        margin:0px 25px;
        font-size: 16px;
        font-family: Microsoft YaHei  !important;
        font-weight:400 !important;
        color: #000000 ;
        border-left:none;
        height: 40px;
        line-height: 40px;
        &:not(:first-child){
          &:before{
            content: '';
            display: inline-block;
            height: 24px;
            border-left: 1px solid #E4E7ED;
            position: absolute;
            left: -23px;
            top: 8px;
          }
        }
      }
      /deep/ .el-tabs__item.is-active {
        color: #b79255;
        font-weight:700;
        border-bottom: 2px solid #b79255;
      }
      /deep/ .el-tabs__item:hover {
        color: #b79255;

      }
      /deep/ .el-tabs--card > .el-tabs__header .el-tabs__nav{
      border:none;
      }
      /deep/ .el-tabs {
        .el-tabs__header {
          margin: 0;
        }
        .el-tabs__content {
          padding: 20px;
        }
      }
      /deep/.el-col{
        display: flex;
        margin: 7px 0;
        .label{
          color: #666;
          font-size: 14px;
          // min-width: 70px;
        }
        .context{
          color: #333;
          font-size: 14px;
          display: inline-block;
          word-break:break-all;
          .el-image{
            >img{
              width: 100px;
              height: 100px;
              margin-right: 10px;
            }
          }
        }
      }
    }
  }
}
.recommendList{
  margin-top: 10px;
  background-color: #FFFFFF;
  border: 1px solid #E4E7ED;
  .title {
    font-weight: normal !important;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 20px 0;
    border-bottom: 1px solid #E4E7ED;
    .name{
      color: #B79255;
      font-size: 16px;
      height: 15px;
      padding-left: 10px;
      border-left: 3px solid #B79255;
      line-height: 15px;
      margin: 10px 0px;
    }
    .more {
      cursor: pointer;
      font-size: 14px;
      color: #666666;
      display: flex;
      align-items: center;
      img {
        margin-left: 5px;
        width: 16px;
        height: 16px;
      }
    }
  }
  /deep/ .empty-data .nodata .message{
    line-height: 1;
  }
}
</style>
<style lang="scss">
.item_top {
  .el-button--primary {
    color: #fff;
    background-color: #b79255;
    border-color: #b79255;
  }
}
</style>
<style lang="scss" rel="stylesheet/scss">
.popperCustoms {
  padding: 5px 10px!important;
  &.is-light {
    background: #ffffff !important;
    border: 1px solid #666666;
    box-shadow: 0px 3px 10px 0px rgba(0, 0, 0, 0.08);
    border-radius: 0;
    opacity: 1 !important;
    color: #666666 !important;
  }
}
</style>